import React from "react";
import { IPage } from "api/entities/page";
import Table, {
  IColumnDefinition,
  TableSelected,
} from "components/shared-ui/table/table";
import styles from "./policy-table.module.scss";
import { useNavigate } from "react-router-dom";
import tableStyles from "../../shared-ui/table/table.module.scss";
import { routeUtils } from "utils/route-utils";
import { IIAMEntityRequestParams } from "api/entities/iam-entity";
import { MoreOption } from "../../shared-ui/iam/moreoption";
import {
  IAMPolicySortField,
  IAMPolicyType,
  IIAMPolicy,
} from "api/entities/iam-policies";
import { useApi } from "utils/hooks/use-api";
import { iamService } from "api/services/iam";
import { Formatters } from "helper/formatters";

export interface IAMPolicyTableProps {
  isLoading: boolean;
  page: IPage<IIAMPolicy>;
  requestParams: IIAMEntityRequestParams<IAMPolicySortField>;
  setRequestParams: (data: IIAMEntityRequestParams<IAMPolicySortField>) => void;

  selection?: TableSelected<IIAMPolicy>;
  onSelectionChanged?: (selection: TableSelected<IIAMPolicy>) => void;
  onSelectAll?: () => void;

  isRowClickable?: boolean;
  hasManageColumn?: boolean;
}

export const IAMPolicyTable = (props: IAMPolicyTableProps) => {
  const [api] = useApi();
  const navigate = useNavigate();
  const isManaged = async (arn: string) => {
    return (
      (await api(iamService.getPolicyVersion({ PolicyArn: arn })))?.Type ===
      IAMPolicyType.Managed
    );
  };
  const columns: IColumnDefinition<IIAMPolicy, IAMPolicySortField>[] = [
    {
      label: "Name",
      className: styles["col--name"],
      formatter: (row) => row.PolicyName,
      sortKey: IAMPolicySortField.PolicyName,
    },
    {
      label: "Attachment Count",
      className: styles["col--name"],
      formatter: (row) => row.AttachmentCount,
      sortKey: IAMPolicySortField.AttachmentCount,
    },
    {
      label: "ARN",
      className: styles["col--arn"],
      formatter: (row) => row.Arn,
      sortKey: IAMPolicySortField.ARN,
    },
    {
      label: "Created At",
      className: styles["col--create-date"],
      formatter: (row) => Formatters.formatDateTime(row.CreateDate),
      sortKey: IAMPolicySortField.CreateDate,
    },
  ];

  if (props.hasManageColumn) {
    columns.push({
      label: "Manage",
      className: tableStyles["col--manage"],
      formatter: (row) => (
        <MoreOption
          systemManaged={() => isManaged(row.Arn)}
          data={row}
          routeGetter={routeUtils.getRouteToIAMPolicyDetails}
        />
      ),
    });
  }

  return (
    <Table
      testId="iam-group-table"
      columns={columns}
      hideCheckbox={!props.selection}
      loading={props.isLoading}
      rows={props.page.data}
      totalRows={props.page.count}
      onRowClick={(row) =>
        !!props.isRowClickable &&
        navigate(routeUtils.getRouteToIAMPolicyDetails(row.id))
      }
      selected={props.selection}
      onSetSelected={props.onSelectionChanged}
      onSelectAll={props.onSelectAll}
      responsive
      requestParams={props.requestParams}
    />
  );
};
